import { Box } from "@material-ui/core";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import KeyboardBackspaceSharpIcon from "@material-ui/icons/KeyboardBackspaceSharp";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import React, { memo } from "react";
import { useHistory } from "react-router-dom";
import { useStyles } from "./style";

const FormPageHeader = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const {
    hasCustomRedirect,
    customRedirectPath,
    title,
    customTitle,
    mode,
    pageName,
    parentLink,
  } = props;
  return (
    <>
      <Box className={classes.headerContainer}>
        <Box className={classes.pageHeaderWrap}>
          <Box className={classes.formHeader}>
            <Box
              className={classes.backIcon}
              onClick={() => {
                if (hasCustomRedirect && customRedirectPath) {
                  history.push(customRedirectPath);
                } else {
                  history.goBack();
                }
              }}
            >
              <KeyboardBackspaceSharpIcon />
            </Box>
            <h1 className={classes.header}>
              {customTitle
                ? `${title} - ${customTitle.substring(0, 18)}...`
                : `${title}`}
            </h1>
          </Box>
          <Box>
            <Box className={classes.breadcrumbsWrap}>
              <Breadcrumbs
                aria-label="breadcrumb"
                separator={
                  <ChevronRightIcon className={classes.breadcrumbSeparator} />
                }
              >
                <span
                  className={classes.breadcrumbItem}
                  onClick={() => history.push("/d/home")}
                >
                  Home
                </span>
                <span
                  className={classes.breadcrumbItem}
                  onClick={() => parentLink && history.push(parentLink)}
                >
                  {pageName}
                </span>
                <span className={classes.breadcrumbActive}>{mode}</span>
              </Breadcrumbs>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default memo(FormPageHeader);
